import { sanitizeHtml } from '@realadvisor/html-sanitizer';
import { marked } from 'marked';

const sanitizeBacktick = (text: string) => text.replace(/`/g, '&#x60;');

export const parseMarkdown = (
  text: string,
  options?: {
    breaks?: boolean;
    disableLinks?: boolean;
    disableCode?: boolean;
    openLinksInNewTab?: boolean;
  },
): string => {
  const renderer = new marked.Renderer();
  const defaultRenderer = new marked.Renderer();
  if (options?.disableLinks) {
    renderer.link = (_, __, linkText) => linkText;
  } else if (options?.openLinksInNewTab) {
    renderer.link = (href, title, linkText) => {
      return defaultRenderer
        .link(href, title, linkText)
        .replace(/^<a /, '<a target="_blank" rel="noopener noreferrer" ');
    };
  }
  const input = options?.disableCode ? sanitizeBacktick(text) : text;
  return sanitizeHtml(
    marked.parse(input, {
      renderer,
      breaks: options?.breaks ?? true,
    }) as string,
  );
};
